import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.benutzer-info';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerInfoEffects {

    BenutzerInfo$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_BENUTZER_INFO),
        mergeMap((x: ac.GetBenutzerInfoAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getBenutzerInfo().pipe(
                map((result: any) => {
                    return new ac.GetBenutzerInfoErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetBenutzerInfoFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungQueryService);
        }
        return this.service;
    }
}
